import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

export interface WizardStep {
    name: string;
    route: string;
    stepPercentage: number;
    done?: boolean;
    percentage?: number;
    width?: string;
}


@Injectable({
  providedIn: 'root'
})
export class WizardService {

  steps: WizardStep[];
  currStep: number;
  private currPercentage = 0;
  private _percentageId: { [id: string]: 'increase' | 'decrease' } = {};
  movingTo: number;
  onStepChanged: (step: number) => void = step => { };

  constructor(private router: Router, private route: ActivatedRoute) {}

  increasePercentage(id: string, value?: number, stepTimes = false): void {
    if (id && this._percentageId[id] === 'increase') {
      return;
    }
    this._percentageId[id] = 'increase';
    const step = this.steps[this.currStep];
    if (this.currPercentage >= 100 && value !== 100) {
      return;
    }
    if (isNaN(value)) {
      this.currPercentage += step.stepPercentage;
    } else if (stepTimes) {
      this.currPercentage += (value * step.stepPercentage);
    } else {
      this.currPercentage = value;
    }
    this.updatePercentage(step);
  }

  decreasePercentage(id: string, value?: number, stepTimes = false): void {
    if (id && this._percentageId[id] === 'decrease') {
      return;
    }
    this._percentageId[id] = 'decrease';
    const step = this.steps[this.currStep];
    if (this.currPercentage <= 0 && value !== 0) {
      return;
    }
    if (isNaN(value)) {
      this.currPercentage -= step.stepPercentage;
    } else if (stepTimes) {
      this.currPercentage -= (value * step.stepPercentage);
    } else {
      this.currPercentage = value;
    }
    this.updatePercentage(step);
  }

  resetStep(): void {
    this.currPercentage = 0;
    this._percentageId = {};
    const step = this.steps[this.currStep];
    this.updatePercentage(step);
  }

  private updatePercentage(step: WizardStep): void {
    setTimeout(() =>
      step.percentage = this.currPercentage
    );
  }

  setSteps(steps: WizardStep[], selectedStep = 0): void {
    this.steps = steps;
    this.steps.forEach((step, i) => {
      step.width = Math.round(100 / this.steps.length) + '%';
      if (i < selectedStep) {
        step.percentage = 100;
        step.done = true;
      } else {
        step.percentage = 0;
        step.done = false;
      }
    });
    this.currStep = selectedStep;
    // this._stepsSubject.next(this.steps);
    this.navigate(this.currStep);
    // return this._currStepSubject.asObservable();
  }

  nextStep(): void {
    if (this.currStep === this.steps.length) {
      return;
    }

    this.steps[this.currStep].done = true;
    this._percentageId = {};
    this.currPercentage = 0;
    // this.increasePercentage(null, 0);
    // this.currStep++;
    this.navigate(this.currStep + 1);
    // .subscribe(
    //     navigated => {
    //         if (!navigated) {
    //             this.currStep--;
    //         }
    //     });
  }

  previousStep(): void {
    if (this.currStep === 0) {
      return;
    }

    // this.currStep--;
    this.navigate(this.currStep - 1);
    // .subscribe(
    //     navigated => {
    //         if (!navigated) {
    //             this.currStep++;
    //         }
    //     });
  }

  goToStep(step: number) {
    if (step >= 0 && step < this.steps.length) {
      if (step > this.currStep) {
        this.increasePercentage(null, 0);
      }

      // const previousStep = this.currStep;
      // this.currStep = step;
      this.navigate(step);
      // .subscribe(
      //     navigated => {
      //         if (!navigated) {
      //             this.currStep = previousStep;
      //         }
      //     });
    }
  }

  clean(): void {
    this.steps = null;
    this.currStep = null;
    this._percentageId = {};
    this.movingTo = null;
    this.currPercentage = 0;
  }

  private async navigate(to: number): Promise<void> {
    this.movingTo = to;
    const previousStep = this.currStep;
    this.currStep = to;
    const step = this.steps[to];
    const navigated = await this.router.navigate([step.route]);
    try {
      if (navigated) {
        // this._currStepSubject.next(this._steps.indexOf(step));
        this.onStepChanged(this.currStep);
      } else {
        this.currStep = previousStep;
      }
    } catch (err) {
      this.currStep = previousStep;
    }
    // return Observable.fromPromise(this.router.navigate([step.route]))
    //     .do(navigated => {
    //         if (navigated) {
    //             this.currStepSubject.next(this._steps.indexOf(step));
    //         }
    //     });
  }
}
